import { OverclaimShareDisplayHelper } from '@App/helpers/overclaim-share-display-helper'
import { WorkModel } from '@Entities/work/work'
import { OverclaimViewModel } from '@Entities/overclaim/overclaim-view'

const ACTIONABLE_OVERCLAIM_STATUSES = ['OVERCLAIM', 'DISPUTE']

export const isOverclaimHelper = (work?: OverclaimViewModel | WorkModel) => {
    const totalOverclaim = OverclaimShareDisplayHelper(work?.totalKnownShares)
    return totalOverclaim ? totalOverclaim > 0 && work?.overclaimStatusFilter === 'OVERCLAIM' : false
}

export const isActionableOverclaimHelper = (work?: OverclaimViewModel | WorkModel) => {
    const totalOverclaim = OverclaimShareDisplayHelper(work?.totalKnownShares)
    return totalOverclaim
        ? totalOverclaim > 0 && ACTIONABLE_OVERCLAIM_STATUSES.includes(work?.overclaimStatusFilter ?? '')
        : false
}
